import { useCallback, useState } from "react";
import { Instagram as IgIcon } from "lucide-react";
import { Intro, Lightbox } from "@/components/site/Gallery";
import { MonthCalendar } from "@/components/site/Calendar";
import { imgSrc } from "@/lib/api";
import { ReviewForm } from "@/components/site/ReviewForm";

const initials = (n) => n.split(/\s+/).filter((w) => /^\p{L}/u.test(w)).slice(0, 2).map((w) => w[0]).join("").toUpperCase();
const clamp = (r) => Math.max(0, Math.min(5, r || 0));

const QuotePhotos = ({ t, i, onOpen }) => (
  <div className="quote-photos">
    {t.photos.map((p, j) => (
      <button key={p} type="button" onClick={() => onOpen({ image: p, alt: `Zdjęcie od: ${t.name}`, title: t.name, subtitle: t.occasion })} aria-label="Powiększ zdjęcie" data-testid={`testimonial-${i}-photo-${j}`}>
        <img src={imgSrc(p)} alt="" loading="lazy" />
      </button>
    ))}
  </div>
);

export const Testimonials = ({ c }) => {
  const [open, setOpen] = useState(null);
  const close = useCallback(() => setOpen(null), []);
  return (
    <section id="opinie" data-testid="testimonials-section">
      <Intro c={c} />
      <div className="quotes" style={{ "--cols": c.items.length < 3 ? c.items.length : c.items.length % 3 && c.items.length % 2 === 0 ? 2 : 3 }}>
        {c.items.map((t, i) => (
          <figure key={`${t.name}-${i}`} className="quote" data-testid={`testimonial-${i}`}>
            <div className="stars" aria-label={`Ocena ${t.rating} na 5`}>{"★".repeat(clamp(t.rating))}<span>{"★".repeat(5 - clamp(t.rating))}</span></div>
            <blockquote>„{t.text}”</blockquote>
            {t.photos?.length > 0 && <QuotePhotos t={t} i={i} onOpen={setOpen} />}
            <figcaption>
              {t.image ? <img src={imgSrc(t.image)} alt={t.name} /> : <span className="avatar">{initials(t.name || "?")}</span>}
              <span><b>{t.name}</b>{t.occasion}</span>
            </figcaption>
          </figure>
        ))}
      </div>
      <ReviewForm />
      {open && <Lightbox item={open} onClose={close} />}
    </section>
  );
};

const IgTile = ({ it, i }) => {
  const img = <img src={imgSrc(it.image)} alt={it.alt || "Zdjęcie z Instagrama"} loading="lazy" />;
  return it.link ? (
    <a className="ig-tile" href={it.link} target="_blank" rel="noopener noreferrer" data-testid={`instagram-item-${i}`}>{img}<span className="ig-hover"><IgIcon size={26} strokeWidth={1.4} /></span></a>
  ) : (
    <div className="ig-tile" data-testid={`instagram-item-${i}`}>{img}</div>
  );
};

export const InstagramStrip = ({ c }) => {
  const items = c.items.filter((it) => it.image);
  return (
    <section id="instagram" data-testid="instagram-section">
      <Intro c={c} />
      <div className="ig-strip">{items.map((it, i) => <IgTile key={it.image} it={it} i={i} />)}</div>
      {c.profile_url && (
        <a className="btn line" style={{ marginTop: 40 }} href={c.profile_url} target="_blank" rel="noopener noreferrer" data-testid="instagram-profile-btn">
          <IgIcon size={16} strokeWidth={1.6} />{c.button}
        </a>
      )}
    </section>
  );
};

export const Availability = ({ c, date, onPick }) => (
  <section id="terminy" data-testid="availability-section">
    <Intro c={c} />
    <MonthCalendar blocked={c.blocked || []} selected={date} onDay={(d) => { onPick(d); document.getElementById("kontakt")?.scrollIntoView({ behavior: "smooth" }); }} />
  </section>
);
